// adminfrontend/src/admin_ui/services/adminPurchasingApi.js
import adminApiClient from "./adminApiClient";

const adminPurchasingApi = {
  // Suppliers
  async listSuppliers(params) {
    const res = await adminApiClient.get("/api/purchasing/suppliers", { params });
    return res.data;
  },
  async createSupplier(payload) {
    const res = await adminApiClient.post("/api/purchasing/suppliers", payload);
    return res.data;
  },

  // Purchase Orders
  async listPurchaseOrders(params) {
    const res = await adminApiClient.get("/api/purchasing/purchase-orders", { params });
    return res.data;
  },
  async getPurchaseOrder(id) {
    const res = await adminApiClient.get(`/api/purchasing/purchase-orders/${id}`);
    return res.data;
  },
  async createPurchaseOrder(payload) {
    const res = await adminApiClient.post("/api/purchasing/purchase-orders", payload);
    return res.data;
  },
  async approvePurchaseOrder(id) {
    const res = await adminApiClient.post(`/api/purchasing/purchase-orders/${id}/approve`);
    return res.data;
  },
  async markSentPurchaseOrder(id) {
    const res = await adminApiClient.post(`/api/purchasing/purchase-orders/${id}/mark-sent`);
    return res.data;
  },
  async cancelPurchaseOrder(id) {
    const res = await adminApiClient.post(`/api/purchasing/purchase-orders/${id}/cancel`);
    return res.data;
  },

  // Goods Receipts
  async listGoodsReceipts(params) {
    const res = await adminApiClient.get("/api/purchasing/goods-receipts", { params });
    return res.data;
  },
  async createGoodsReceipt(payload) {
    const res = await adminApiClient.post("/api/purchasing/goods-receipts", payload);
    return res.data;
  },
  async postGoodsReceipt(id) {
    const res = await adminApiClient.post(`/api/purchasing/goods-receipts/${id}/post`);
    return res.data;
  },
};

export default adminPurchasingApi;
